import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';

const propTypes = {
  open: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onOk: PropTypes.func.isRequired,
};

export function UnstyledORAlert({ open, message, onCancel, onOk }) {
  return (
    <Dialog open={open} maxWidth="sm">
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button color="primary" onClick={onOk}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}

UnstyledORAlert.propTypes = propTypes;

export default UnstyledORAlert;
